import {TheBorderSymbol} from "../reels/TheBorderSymbol";
import {TheBorder} from "../TheBorder";
import {ISymbol} from "../../core/reel/ReelInterfaces";

/**
 * Created by Jerker Nord on 2022-04-29.
 */
export interface IClusterData {
    info: Set<string>;
    name: string;
    count: number;
    xWaysPositionsInCluster: Set<string>;
    isWRInReels: boolean;
}

export class TheBorderUtils {

    static roundToDecimals(num: number, noOfDecimals: number): number {
        return Number((num).toFixed(noOfDecimals));
    }

    public static getClustersForSymbol(reels: string[][], name: string, checkedSymArr: string[]): IClusterData[] {
        const clusterDataArr: IClusterData[] = [];
        let visitedGrid: string[] = [];

        reels.forEach((rowArr: string[], reelId: number) => {
            rowArr.forEach((symName: string, rowId: number) => {
                if ((checkedSymArr.indexOf(reelId + "_" + rowId) === -1) && (visitedGrid.indexOf(reelId + "_" + rowId) === -1)) {
                    symName = symName.split("_")[0];
                    const currSym: TheBorderSymbol = <TheBorderSymbol>TheBorder.allReelsView.mainReelModels[reelId].reelView.getSymbol(rowId);

                    if (name === symName || name === currSym.symbolName.split("_H")[0]) {
                        const clusterData: IClusterData = {
                            info: new Set<string>(),
                            count: 0,
                            name: name,
                            xWaysPositionsInCluster: new Set<string>(),
                            isWRInReels: false
                        };

                        let searchId: string = reelId + "_" + rowId;
                        this.updateCluster(currSym, clusterData, checkedSymArr, searchId);

                        visitedGrid = visitedGrid.concat(Array.from(clusterData.info));

                        if (clusterData.count >= 5) {
                            clusterDataArr.push(clusterData);
                        }
                    }
                }
            });
        });
        return clusterDataArr;
    }

    public static isWild(symName: string): boolean {
        return TheBorder.wildSymbolNames.indexOf(symName) > -1;
    }

    private static updateCluster(symbol: TheBorderSymbol, clusterObj: IClusterData, allCheckedSymbolArr: string[], searchId: string): void {
        if (allCheckedSymbolArr.indexOf(searchId) === -1 && !clusterObj.info.has(searchId)) {
            !this.isWild(symbol.aliasName) && allCheckedSymbolArr.push(searchId);
            clusterObj.info.add(searchId);
            clusterObj.count += symbol.splitLevel;
            if (TheBorder.model.allXWaysRelatedPositions.indexOf(searchId) > -1) {
                clusterObj.xWaysPositionsInCluster.add(searchId);
            }
            clusterObj.isWRInReels = clusterObj.isWRInReels || (symbol.aliasName.indexOf("WR") > -1);
            this.checkAllDirection(symbol, allCheckedSymbolArr, clusterObj);
        }
    }

    private static checkAllDirection(currentSym: TheBorderSymbol, allCheckedSymbolArr: string[], clusterObj: IClusterData): void {
        //checkRight
        const name: string = clusterObj.name;
        let searchId: string,
            comparedReelId: number = currentSym.reelId + 1;

        if (comparedReelId < 6) {
            const symArr: TheBorderSymbol[] = <TheBorderSymbol[]>TheBorder.allReelsView.mainReelModels[comparedReelId].reelView.getSymbolsClosestToYPos(currentSym.position.y, (currentSym.sizeMultiplier * 100));
            symArr.forEach((sym: TheBorderSymbol) => {
                if (sym.aliasName === name || sym.aliasName === name + "_H" || this.isWild(sym.aliasName)) {
                    searchId = sym.reelId + "_" + (sym.reelPosition - 1);
                    this.updateCluster(sym, clusterObj, allCheckedSymbolArr, searchId);
                }
            });
        }
        //check left
        comparedReelId = currentSym.reelId - 1;
        if (comparedReelId >= 0) {
            const symArr: TheBorderSymbol[] = <TheBorderSymbol[]>TheBorder.allReelsView.mainReelModels[comparedReelId].reelView.getSymbolsClosestToYPos(currentSym.position.y, (currentSym.sizeMultiplier * 100));
            symArr.forEach((sym: TheBorderSymbol) => {
                if (sym.aliasName === name || sym.aliasName === name + "_H" || this.isWild(sym.aliasName)) {
                    searchId = sym.reelId + "_" + (sym.reelPosition - 1);
                    this.updateCluster(sym, clusterObj, allCheckedSymbolArr, searchId);
                }
            });
        }

        //check top
        const topRow: number = currentSym.reelPosition - 2;
        if (topRow >= 0) {
            const topSym: TheBorderSymbol = <TheBorderSymbol>TheBorder.allReelsView.mainReelModels[currentSym.reelId].reelView.getSymbol(topRow);
            if (topSym.aliasName === name || topSym.aliasName === name + "_H" || this.isWild(topSym.aliasName)) {
                searchId = currentSym.reelId + "_" + topRow;
                this.updateCluster(topSym, clusterObj, allCheckedSymbolArr, searchId);
            }
        }
        //check bottom
        const bottomRow: number = currentSym.reelPosition;
        if (bottomRow < TheBorder.allReelsView.getReelLength(currentSym.reelId)) {
            const bottomSym: TheBorderSymbol = <TheBorderSymbol>TheBorder.allReelsView.mainReelModels[currentSym.reelId].reelView.getSymbol(bottomRow);
            if (bottomSym.aliasName === name || bottomSym.aliasName === name + "_H" || this.isWild(bottomSym.aliasName)) {
                searchId = currentSym.reelId + "_" + bottomRow;
                this.updateCluster(bottomSym, clusterObj, allCheckedSymbolArr, searchId);
            }
        }
    }
}